import Product from './Product.jsx';
import ProductBrief from './ProductBrief.jsx';

export default Product;
export {Product, ProductBrief}



// WEBPACK FOOTER //
// ./components/partials/product/index.js